module.exports = __webpack_public_path__ + "img/LT112044379.74e9a404.png";